import React from "react";
import { Modal } from "react-bootstrap";
import InputOnlyNumber from "../../common/Input/InputOnlyNumber";
const AddUpdateRadiologyServicesMaste = ({
  modalVisible,
  setModalVisible,
  handleAddOrUpdateRadiologyMaster,
  handleSetRadiologyMasterFormData,
  radiologyMasterFormData,
  setInputError,
}) => {
  
  return (
    <>
      <Modal
        centered
        show={modalVisible}
        onHide={() => setModalVisible(false)}
        size="lg"
      >
        <div className="modal-header">
          <h3 className="modal-title" id="exampleModalLabel">
            Update Radiology Services
          </h3>
          <button
            type="button"
            className="btn-close"
            onClick={() => setModalVisible(false)}
          ></button>
        </div>
        <div className="modal-body">
          <form onSubmit={handleAddOrUpdateRadiologyMaster}>
            <div className="row">
              <div className="col-xl-6">
                <div className="form-group position-relative">
                  <label htmlFor="radiologyServiceName" className="col-form-label">
                    Radilogy Service Name:
                  </label>
                  <input
                    name="name"
                    value={radiologyMasterFormData?.serviceName}
                    type="text"
                    className="form-control"
                    placeholder="Radiology Service Name"
                    readOnly
                  />
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group">
                  <label htmlFor="message-text" className="col-form-label">
                    Radiology Service Details Name :
                  </label>
                  <input
                    name="name"
                    value={radiologyMasterFormData?.name}
                    onChange={(e) => handleSetRadiologyMasterFormData(e)}
                    type="text"
                    className="form-control"
                    placeholder="Radiology Service Name"
                    readOnly
                  />
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group">
                  <label htmlFor="message-text" className="col-form-label">
                    Service Weight :
                  </label>
                  <input
                    name="weight"
                    value={radiologyMasterFormData?.weight}
                    onChange={(e) => handleSetRadiologyMasterFormData(e)}
                    type="text"
                    className="form-control"
                    placeholder="Service Weight"
                  />
                </div>
              </div>
              <div className="col-xl-6">
              <InputOnlyNumber
              name="pt_price"
              value={radiologyMasterFormData?.pt_price}
              onChange={(e) => handleSetRadiologyMasterFormData(e)}
              placeholder="Patient Price"
              label="Patient Price"
              fieldName="pt_price"
              setInputOnlyNumberError={setInputError}
            />
              </div>
              <div className="col-xl-6">
              <InputOnlyNumber
              name="client_Price"
              value={radiologyMasterFormData?.client_Price}
              onChange={(e) => handleSetRadiologyMasterFormData(e)}
              label="client Price"
              placeholder="Client Price"
              fieldName="client_Price"
              setInputOnlyNumberError={setInputError}
            />
              </div>
              <div className="col-xl-6">
                <div className="form-group">
                  <label htmlFor="message-text" className="col-form-label">
                    TAX :
                  </label>
                  <input
                    name="tax"
                    value={radiologyMasterFormData?.tax}
                    onChange={(e) => handleSetRadiologyMasterFormData(e)}
                    type="text"
                    className="form-control"
                    placeholder="TAX"
                  />
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group d-flex align-items-center">
                  <label htmlFor="status" className="col-form-label me-3">
                    Status:
                  </label>
                  {["Active", "Inactive", "Deleted"].map((status) => (
                    <div className="form-check me-3" key={status}>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="status"
                        id={status.toLowerCase()}
                        value={status}
                        checked={radiologyMasterFormData?.status === status}
                        onChange={(e) => handleSetRadiologyMasterFormData(e)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={status.toLowerCase()}
                      >
                        {status}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setModalVisible(false)}
              >
                Close
              </button>
              <button type="submit" className="btn btn-success">
                Update
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};

export default AddUpdateRadiologyServicesMaste;